<template>
    <div class="file-container">
        <btn v-bind:text="text" class="display-block btn-outline"></btn>
        <input type="file" id="file" ref="file" @change="onFileSelect"
               v-validate="'size:102400'" data-vv-as="file" name="file">
        <span class="md-error help is-danger"
              v-bind:class="{'visible': errors.has('file') }">
              Maksymalny dopuszczalny rozmiar załącznika to 100MB.</span>
    </div>
</template>

<script>
export default {
  name: 'File',
  props: ['text', 'reference'],
  methods: {
    onFileSelect() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('change', this.$refs.file);
        }
      });
    },
  },
};
</script>

<style src="./File.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/File/File.vue